import { render } from "./AppBar.vue?vue&type=template&id=af262baa"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projets\\2023\\PNB\\GECD\\gecd-police-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__